// Horizon-style module for syntax highlighting in blog posts
import hljs from '@theme/code-highlight';

export function initHighlight() {
  document.querySelectorAll('pre code').forEach(block => hljs.highlightElement(block));
}

// Run once on page load
document.addEventListener('DOMContentLoaded', initHighlight);

// Re-run automatically after each page transition
window.addEventListener('page-transition:done', initHighlight);